import React, { useState } from 'react';
import { Heading, VStack, useRadioGroup, Text } from '@chakra-ui/react'
import { UserRoleProps } from '../../types/page';
import { useHistory } from 'react-router-dom';
import { Spinner } from '@chakra-ui/react'
import { userRoles } from '../../utilities/dummy';
import SvgIcon from '../../components/ui/icons/SvgIcon';
import { RadioCard } from '../../components/ui/radio/RadioCard';
import CustomButton from '../../components/ui/buttons/Button';
import appsList from '../../assets/json/applications.json'

export default function Customer({ roles = userRoles, loading = false }: UserRoleProps) {
    const history = useHistory();
    const { getRootProps, getRadioProps } = useRadioGroup({
        name: '',
        defaultValue: '',
        onChange: handleRoleChange,
      });
    const [value, setValue] = useState<string>('')
    const customer = { fullName: "Keth & Everyone", }
    
    const group = getRootProps();
    const appInfo = appsList[0]
    
    function handleClick() {
        history.push(`/dashboard/${appInfo.id}/overview`)
    }

    function handleRoleChange(val: string) {
        setValue(val)
    }

    return (
        <div className='layout'>
            {!loading ? (
                <div className="roles-page">
                    <div className="content">
                        <Heading as='h2' size='lg' color={'#666'}>
                            Welcome back, {customer?.fullName}!
                        </Heading>  
                        <Text size='md' color={'#666'} margin='24px 0'>
                            Select a role to continue
                        </Text>
                        <div>
                            <VStack spacing={4} {...group}>
                                {roles.map((role) => {
                                    const radio = getRadioProps({ value: role.type })                                    
                                    return (
                                        <RadioCard 
                                           type='card'
                                            key={role.type} 
                                            // {...radio} 
                                            radioProps={radio}
                                            boxProps={{ height: '90px' }}
                                        >
                                            <SvgIcon 
                                                type={role.label}                                            
                                                width="40px" 
                                                height="40px" 
                                                viewBox="0 0 36 36"
                                                color={radio.isChecked ? '#2b6cb0' : ''}
                                                styles={{ marginRight: '8px' }}
                                            />
                                            <Heading as='h4' size='md' flexGrow={1} margin='20px 10px 20px 20px'>
                                                {role.label}
                                            </Heading>
                                        </RadioCard>
                                    )
                                })}
                            </VStack>
                        </div>
                        <div className="mt--10">
                            <CustomButton  
                                onClick={handleClick}
                                label="Continue"
                                cta='primary'
                                type='button'
                                variant='solid' 
                                width='100%'
                                size='md'
                                disabled={!value}
                            />
                        </div>
                    </div>
                </div>
            ): <Spinner />}
        </div>
    )
}